import React, { useState } from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';

export default function MagasinierLayout() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const user = JSON.parse(localStorage.getItem('user') || '{}');

    const handleLogout = () => {
        localStorage.clear();
        toast.success('Déconnexion réussie');
        navigate('/login');
    };

    const menuItems = [
        { path: '/magasin/stocks', name: 'Gestion des stocks', icon: '📦' },
         { path: '/messagerie', name: 'Messagerie', icon: '💬' },
        { path: '/tv-sahel', name: 'TV Sahel', icon: '📺' },
        { path: '/magasin/feed', name: 'Fil d\'actualité', icon: '✨' },
        { path: '/magasin/mes-medias', name: 'Mes médias', icon: '📱' },
        { path: '/messages-techniques', name: 'Messages', icon: '💬' },
        { path: '/magasin/profil', name: 'Mon profil', icon: '👤' },
    ];

    const isActive = (path) => {
        return location.pathname === path;
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
            {/* Sidebar Desktop */}
            <div className="hidden lg:flex lg:flex-col lg:w-64 lg:fixed lg:left-0 lg:top-0 lg:h-full lg:bg-gradient-to-b lg:from-sky-800 lg:to-sky-950 lg:text-white lg:shadow-xl">
                <div className="flex flex-col h-full">
                    <div className="flex-shrink-0 p-5 border-b border-sky-700/50">
                        <div className="text-center">
                            <div className="w-14 h-14 bg-sky-600/30 rounded-full flex items-center justify-center mx-auto mb-2">
                                <span className="text-2xl">📦</span>
                            </div>
                            <h2 className="text-lg font-bold">Espace Magasinier</h2>
                            <p className="text-xs text-sky-300 mt-0.5">{user.prenom} {user.nom}</p>
                        </div>
                    </div>
                    <div className="flex-1 overflow-y-auto py-3 px-3 space-y-1">
                        {menuItems.map((item) => (
                            <Link
                                key={item.path}
                                to={item.path}
                                className={`flex items-center gap-3 px-3 py-2 rounded-lg transition text-sm ${
                                    isActive(item.path)
                                        ? 'bg-sky-600 text-white'
                                        : 'hover:bg-sky-700/50 text-sky-100'
                                }`}
                            >
                                <span className="text-lg">{item.icon}</span>
                                <span className="flex-1">{item.name}</span>
                            </Link>
                        ))}
                    </div>
                    <div className="flex-shrink-0 p-3 border-t border-sky-700/50">
                        <button onClick={handleLogout} className="w-full flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-red-600/30 text-sky-100 transition text-sm">
                            <span className="text-lg">🚪</span>
                            <span>Déconnexion</span>
                        </button>
                    </div>
                </div>
            </div>

            {/* Bouton menu mobile */}
            <button onClick={() => setMobileMenuOpen(true)} className="fixed top-4 left-4 z-30 lg:hidden bg-sky-600 text-white p-2 rounded shadow-lg">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
            </button>

            {/* Sidebar mobile */}
            {mobileMenuOpen && (
                <>
                    <div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={() => setMobileMenuOpen(false)} />
                    <div className="fixed top-0 left-0 h-full w-64 bg-gradient-to-b from-sky-800 to-sky-950 text-white z-50">
                        <div className="flex flex-col h-full">
                            <div className="flex-shrink-0 p-5 border-b border-sky-700/50">
                                <div className="flex justify-between items-center">
                                    <div className="text-center flex-1">
                                        <div className="w-12 h-12 bg-sky-600/30 rounded-full flex items-center justify-center mx-auto mb-2">
                                            <span className="text-2xl">📦</span>
                                        </div>
                                        <h2 className="text-lg font-bold">Espace Magasinier</h2>
                                        <p className="text-xs text-sky-300 mt-0.5">{user.prenom} {user.nom}</p>
                                    </div>
                                    <button onClick={() => setMobileMenuOpen(false)} className="text-white/70 hover:text-white text-2xl">✕</button>
                                </div>
                            </div>
                            <div className="flex-1 overflow-y-auto py-3 px-3 space-y-1">
                                {menuItems.map((item) => (
                                    <Link key={item.path} to={item.path} onClick={() => setMobileMenuOpen(false)} 
                                        className={`flex items-center gap-3 px-3 py-2 rounded-lg transition text-sm ${
                                            isActive(item.path) ? 'bg-sky-600 text-white' : 'hover:bg-sky-700/50 text-sky-100'
                                        }`}>
                                        <span className="text-lg">{item.icon}</span>
                                        <span className="flex-1">{item.name}</span>
                                    </Link>
                                ))}
                            </div>
                            <div className="flex-shrink-0 p-3 border-t border-sky-700/50">
                                <button onClick={handleLogout} className="w-full flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-red-600/30 text-sky-100 transition text-sm">
                                    <span className="text-lg">🚪</span>
                                    <span>Déconnexion</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {/* Contenu principal */}
            <div className="lg:ml-64">
                <Outlet />
            </div>
        </div>
    );
}